const initialState = {
  loading: false,
  permissionGroups: [],
};

const permissionGroupsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_PERMISSION_GROUPS_SUCCESS': {
      return {
        loading: false,
        permissionGroups: action.payload.map(({ name, id }) => ({
          name,
          id,
        })),
      };
    }
    default:
      return state;
  }
};

export default permissionGroupsReducer;
